import { InputAdornment, TextField, type SxProps } from '@mui/material';
import { forwardRef } from 'react';

import { Icon } from '../shared/icon';

export const SearchTextBox = forwardRef<
  HTMLInputElement,
  {
    sx?: SxProps;
    value: string;
    placeholder?: string;
    onChange: (value: string) => void;
    hideIcon?: boolean;
    onEnter?: () => void;
    onTab?: () => void;
    autoFocus?: boolean;
  }
>(function (
  { sx, value, placeholder, onChange, hideIcon, onEnter, onTab, autoFocus },
  ref
) {
  return (
    <TextField
      autoFocus={autoFocus}
      sx={{
        '.MuiInputBase-root': {
          height: '32px',
          paddingLeft: '4px',
          paddingRight: '4px',
        },
        '.MuiInputBase-input': {
          ...(!hideIcon && { paddingLeft: 0 }),
        },
        '.MuiInputAdornment-root': {
          margin: '0px',
        },
        ...sx,
      }}
      value={value}
      onKeyDown={
        onEnter || onTab
          ? (e) => {
              if (onEnter && e.key === 'Enter') {
                onEnter();
              }

              if (onTab && e.key === 'Tab') {
                onTab();
              }
            }
          : undefined
      }
      inputRef={ref}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      InputProps={{
        startAdornment: !hideIcon && (
          <InputAdornment position='start'>
            <Icon iconClass='material-symbols-search' />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position='end'>
            <Icon
              iconClass='material-symbols-close-rounded'
              onClick={() => onChange('')}
            />
          </InputAdornment>
        ),
      }}
    />
  );
});
